import React, { useEffect, useRef, useState } from "react";
import { Box, Button, CircularProgress } from "@mui/material";
import CustomButton from "shared/custom-button/CustomButton";
import styles from "features/cancer-protection/step-3/ui/Pay.module.css";
import { useAppDispatch, useAppSelector } from "shared/utils/hooks/useRedux";
import {
  FormFieldsStepOne,
  Programs,
} from "entities/cancer-protection/step-1/selector";
import CurrencyRubleIcon from "@mui/icons-material/CurrencyRuble";
import {
  files,
  FormFieldsStepTree,
  saveProjectState,
} from "entities/cancer-protection/step-3/selector";
import InfoIcon from "@mui/icons-material/Info";
import {
  CountriesData,
  FormFieldsStepTwo,
} from "entities/cancer-protection/step-2/selsctor";
import {
  fetchCreateInsuranceContractProjects,
  fetchCreateInsuranceContracts,
} from "entities/cancer-protection/step-3/action/fetch-step-tree";
import { colors } from "app/providers/theme/colors-type";
import { getRequestProductSales } from "shared/utils/fetch-api";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import Loader from "shared/loader/Loader";
import FileIcon from "shared/assets/FileIcon";
import { updateField } from "entities/cancer-protection/step-2";
import { useNavigate } from "react-router-dom";
import { RoutesType } from "shared/types/routes/routers-type";

interface PayProps {
  handleNext: () => void;
  handleBack: () => void;
  windowWidth: number;
  handleNextStep: () => void;
  setTriggerPay: (value: boolean) => void;
}

export const Pay: React.FC<PayProps> = ({
  handleNext,
  handleBack,
  windowWidth,
  handleNextStep,
  setTriggerPay,
}) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const fieldsStepOne = useAppSelector(FormFieldsStepOne);
  const fieldsStepTwo = useAppSelector(FormFieldsStepTwo);
  const fieldsStepTree = useAppSelector(FormFieldsStepTree);

  const { AgentSalesDataID } = useAppSelector(FormFieldsStepOne);

  const { PayLink, ID, errorSaveProjects, isLoadingSaveProject } =
    useAppSelector(saveProjectState);

  const { isLoadingFiles, Files, errorFiles, Policies } = useAppSelector(files);

  const [paymentStatus, setPaymentStatus] = useState<boolean>(false);
  const [isPaymentInProgress, setIsPaymentInProgress] =
    useState<boolean>(false);
  const pollingTimerRef = useRef<NodeJS.Timeout | null>(null);

  const formatNumberWithSpaces = (number: number): string => {
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
  };
  const { Countries } = useAppSelector(CountriesData);
  const isRussia =
    Countries?.find((country) => country.ID === fieldsStepTwo.Insurer.CountryID)
      ?.Name === "РОССИЯ";
  useEffect(() => {
    if (!isRussia) {
      const updatedInsurer = {
        ...fieldsStepTwo.Insurer,
        DepartmentCode: "",
        DocumentDepartment: "",
      };
      dispatch(updateField({ field: "Insurer", value: updatedInsurer }));
    }
  }, [isRussia, dispatch]);

  const saveProject = async () => {
    await dispatch(
      fetchCreateInsuranceContractProjects({
        BeginDate: fieldsStepTwo.BeginDate,
        Insurer: fieldsStepTwo.Insurer,
        Insureds: fieldsStepTwo.Insureds,
        RegionID: fieldsStepOne.Programs.Regions[0],
        CalculationRequestID: fieldsStepTree.Programs.RequestID,
        ProgramsIDs: fieldsStepTree.SelectedProgramsIds,
        AgentSalesDataID: AgentSalesDataID,
      })
    );
  };

  useEffect(() => {
    saveProject();
  }, []);
  const checkPaymentStatus = async () => {
    try {
      const response = await getRequestProductSales(
        { InvoiceID: ID, AgentSalesDataID: AgentSalesDataID, Source: "Site" },
        "product-sales",
        "checkInvoicePaymentStatus",
        "POST"
      );
      const result = await response.json();
      if (result.Paid) {
        setPaymentStatus(true);
        setIsPaymentInProgress(false);
        if (pollingTimerRef.current) {
          clearInterval(pollingTimerRef.current);
        }
      }
    } catch (error) {
      console.error("Ошибка при проверке статуса оплаты:", error);
    }
  };
  const startPolling = () => {
    setIsPaymentInProgress(true);
    pollingTimerRef.current = setInterval(async () => {
      await checkPaymentStatus();
    }, 3000);

    setTimeout(() => {
      if (pollingTimerRef.current) {
        clearInterval(pollingTimerRef.current);
        setIsPaymentInProgress(false);
      }
    }, 1800000);
  };
  useEffect(() => {
    if (paymentStatus) {
      dispatch(
        fetchCreateInsuranceContracts({
          InvoiceID: ID,
          AgentSalesDataID: AgentSalesDataID,
        })
      );
    }
  }, [paymentStatus]);

  const handlePay = () => {
    setTriggerPay(true);
    if (PayLink) {
      window.open(PayLink, "_blank");
      startPolling();
    }
  };
  useEffect(() => {
    return () => {
      if (pollingTimerRef.current) {
        clearInterval(pollingTimerRef.current);
      }
    };
  }, []);
  const [isloadingPolicy, setIsLoadingPolicy] = useState(false);
  const handleDownloadPolicy = async (idFile: string) => {
    try {
      setIsLoadingPolicy(true);
      const response = await getRequestProductSales(
        { FileId: idFile, AgentSalesDataID: AgentSalesDataID, Source: "Site" },
        "product-sales",
        "fileDownload",
        "POST"
      );
      const result = await response.json();

      if (result.File) {
        const byteCharactersPolis = atob(result.File.DataBase64);
        const byteNumbersPolis = new Array(byteCharactersPolis.length);
        for (let i = 0; i < byteCharactersPolis.length; i++) {
          byteNumbersPolis[i] = byteCharactersPolis.charCodeAt(i);
        }
        const byteArrayPolis = new Uint8Array(byteNumbersPolis);
        const blobPolis = new Blob([byteArrayPolis], {
          type: "application/pdf",
        });
        const blobUrlPolis = URL.createObjectURL(blobPolis);
        const linkPolis = document.createElement("a");
        linkPolis.href = blobUrlPolis;
        linkPolis.download = result.File.Name;
        document.body.appendChild(linkPolis);
        linkPolis.click();
        document.body.removeChild(linkPolis);
        URL.revokeObjectURL(blobUrlPolis);
      }
    } catch (error) {
      console.error("Ошибка при скачивании:", error);
    } finally {
      setIsLoadingPolicy(false);
    }
  };
  const handleClickBtn = () => {
    navigate(RoutesType.FeedbackMaxBot, {
      state: {
        policyId: Policies[0].ID,
        masterSystem: "0",
      },
    });
    console.log(1);
    
  };
  if (errorSaveProjects.length > 0 || (!PayLink && !isLoadingSaveProject)) {
    return (
      <>
        <Box className={styles.colorBox}>
          <span className={styles.icon}>
            <InfoIcon />
          </span>
          <p>
            {errorSaveProjects.length && errorSaveProjects[0].Msg
              ? errorSaveProjects[0].Msg
              : "Что-то пошло не так"}
          </p>
        </Box>

        <Box className={styles.btnBoxUpdate}>
          {isLoadingSaveProject ? (
            <CircularProgress color="inherit" size={20} />
          ) : (
            <CustomButton
              title="Обновить"
              handleClick={saveProject}
              textColor="white"
              backgroundColor={colors.primary}
              width="150px"
              gap="10px"
              borderRadius="4px"
              padding="3px"
            />
          )}
        </Box>
      </>
    );
  }
  if (isLoadingSaveProject) {
    return <Loader title="Подготавливаем ссылку на оплату..." />;
  }
  if (isLoadingFiles) {
    return <Loader title="Подготавливаем полис..." />;
  }
  if (isPaymentInProgress) {
    return <Loader title="Обработка оплаты..." />;
  }
  if (paymentStatus) {
    return (
      <>
        <Box className={styles.successMessage}>
          <span>
            <CheckCircleOutlineIcon />
          </span>
          <p>Успешная оплата!</p>
        </Box>
        <Box className={styles.colorBox}>
          <span className={styles.icon}>
            <InfoIcon />
          </span>
          <p>Ваш полис готов. Вы можете скачать его по кнопке ниже.</p>
        </Box>
        {Files.length > 0 && (
          <Box className={styles.filesBox}>
            {isloadingPolicy ? (
              <CircularProgress color="inherit" size={20} />
            ) : (
              <>
                {Files.map((file, index) => (
                  <Box key={index}>
                    <CustomButton
                      title={file.ProductTitle}
                      handleClick={() => handleDownloadPolicy(file.ID)}
                      textColor="white"
                      backgroundColor={colors.primary}
                      width="150px"
                      gap="10px"
                      borderRadius="4px"
                      padding="3px"
                    />
                  </Box>
                ))}
              </>
            )}
          </Box>
        )}
        <Box className={styles.RewieBox}>
          <p>Оцените, пожалуйста, удобство покупки в нашем новом сервисе</p>
          <Box className={styles.btnBoxRewie}>
            <Button
              className={styles.gradientButton}
              variant="contained"
              onClick={handleClickBtn}
            >
              Оставить отзыв
            </Button>
          </Box>
        </Box>
      </>
    );
  }

  return (
    <Box className={styles.formBox}>
      <Box className={styles.titleBox}>
        <h4>Проверьте сумму и нажмите кнопку "Оплатить"</h4>
      </Box>
      <Box className={styles.fieldBox}>
        <Box className={styles.premium}>
          <span>
            {formatNumberWithSpaces(fieldsStepTree.FinalPremium)}{" "}
            <CurrencyRubleIcon fontSize="small" />
          </span>
        </Box>

        <Box className={styles.colorBox}>
          <span className={styles.icon}>
            <InfoIcon />
          </span>
          <p>Чек об оплате и полис придет на указанную почту</p>
        </Box>

        {PayLink && (
          <Box className={styles.btnBox}>
            <CustomButton
              title="Назад"
              handleClick={handleBack}
              textColor={colors.primary}
              backgroundColor="none"
              width="150px"
              gap="10px"
              borderRadius="4px"
              padding="3px"
              border="none"
            />
            <CustomButton
              title="Оплатить"
              handleClick={handlePay}
              textColor="white"
              backgroundColor={colors.primary}
              width="150px"
              gap="10px"
              borderRadius="4px"
              padding="3px"
            />
          </Box>
        )}
      </Box>
    </Box>
  );
};
